<template>
  <div>
    <!-- 编辑 -->
    <el-dialog
      :title="!dataForm.id ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="visible"
      destroy-on-close
      :before-close="handleClose"
    >
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        @keyup.enter.native="dataFormSubmit()"
        label-width="80px"
        v-loading="loading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动名称" prop="name">
              <el-input
                v-model="dataForm.name"
                placeholder="活动名称"
                clear
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券" prop="storeCouponId">
              <el-select
                v-model="dataForm.storeCouponId"
                style="width: 100%"
                filterable
                placeholder="请选择优惠券"
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动状态" prop="status">
              <el-select v-model="dataForm.status" style="width: 100%">
                <el-option
                  v-for="item in activityStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="banner" prop="banner">
              <el-input
                v-model="dataForm.banner"
                placeholder="活动名称"
                clear
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动介绍" prop="description">
              <div id="editor"></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  storeActivityInfo,
  storeActivitySave,
  storeCouponList
} from "@/api/store";
import E from "wangeditor";
export default {
  name: "activityEdit",
  data() {
    return {
      visible: false,
      dataForm: {},
      dataRule: {
        name: [
          { required: true, message: "活动名称不能为空", trigger: "blur" }
        ],
        storeCouponId: [
          { required: true, message: "优惠券不能为空", trigger: "change" }
        ],
        status: [
          { required: true, message: "活动状态不能为空", trigger: "change" }
        ]
      },
      couponList: [],
      activityStatusOptions: [],
      loading: false
    };
  },
  created() {
    this.loadCouponList();
  },
  mounted() {},
  methods: {
    loadCouponList() {
      console.log("loadCouponList");
      storeCouponList().then(res => {
        if (res.data.status == 100) {
          this.couponList = res.data.results;
        }
      });
    },
    createEditor() {
      this.editor = new E("#editor");
      console.log(this.editor);
      this.editor.config.zIndex = 0;
      this.editor.create();
    },
    open(id, options) {
      if (this.editor) {
        this.editor.destroy();
      }
      this.activityStatusOptions = options.activityStatusOptions;

      this.visible = true;

      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.dataForm = {};
        this.loading = false;
        this.createEditor();
      });
      if (id) {
        this.getActivityInfo(id);
      }
    },
    getActivityInfo(id) {
      this.loading = true;
      storeActivityInfo(id)
        .then(res => {
          if (res.data.status == 100) {
            this.dataForm = res.data.results;
            if (this.editor) {
              this.editor.txt.html(this.dataForm.descriptionHtml);
            }
          } else {
            this.$message({
              message: res.data.message
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.visible = false;
    },
    getFormData() {
      const data = this.dataForm;
      data.descriptionHtml = this.editor.txt.html();
      data.description = this.editor.txt.text();
      return data;
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    saveData() {
      let _self = this;
      const data = this.getFormData();
      this.loading = true;
      storeActivitySave(data)
        .then(res => {
          if (res.data.status == 100) {
            _self.$message({
              message: res.data.message,
              type: "success"
            });
            _self.handleClose();
            _self.$emit("refreshDataList");
          } else {
            _self.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// activityEdit.vue?bcd6097a